import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import queryString from "query-string";

import Description from "../../Components/Description?v=0.0.2";
import HighlightText from "../../Components/HighlightText?v=0.0.2";
import PasswordTextField from "../../Components/PasswordTextField?v=0.0.2";
import * as Constants from "../../Constants?v=0.0.2";

import ForgotPasswordPageImage from "../../Images/ForgotPasswordPageImage.svg";

function InvitedUserPassword(props) {
  document.title = "myBooks | Invited User Password";
  const environment = props.environment;
  const history = useHistory();
  const [password1, setPassword1] = useState("");
  const [containsUpper, setContainsUpper] = useState(false);
  const [containsLower, setContainsLower] = useState(false);
  const [containsSymbol, setContainsSymbol] = useState(false);
  const [containsNumber, setContainsNumber] = useState(false);
  const [passwordDoesNotMatch, setPasswordDoesNotMatch] = useState(false);
  const [hasLength, setHasLength] = useState(false);
  const [password2, setPassword2] = useState("");
  const [accountKey, setAccountKey] = useState("");
  const [showLoader, setShowLoader] = useState(false);
  const [resetButtonClicked, setResetButtonClicked] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    if (
      queryString.parse(window.location.search).ak === undefined ||
      queryString.parse(window.location.search).ak === ""
    ) {
      history.push("myBooks/login");
    }
    setAccountKey(queryString.parse(window.location.search).ak);
  }, [history]);

  const onValidPassword1Handler = (currentPassword) => {
    setPassword1((prevState) => {
      return currentPassword;
    });
    setResetButtonClicked(false);
    setHasLength(currentPassword.length >= 8 && currentPassword.length <= 40);
    setContainsUpper(/[A-Z]/.test(currentPassword));
    setContainsLower(/[a-z]/.test(currentPassword));
    setContainsSymbol(/[^A-Za-z0-9]/.test(currentPassword));
    setContainsNumber(/[0-9]/.test(currentPassword));
  };

  const changePassword1FlagHandler = (flag) => {
    setErrorMessage("");
  };

  const onValidPassword2Handler = (currentPassword) => {
    setPassword2((prevState) => {
      return currentPassword;
    });
    setResetButtonClicked(false);
  };

  const changePassword2FlagHandler = (flag) => {
    setErrorMessage("");
  };

  const ContinueToStep2 = (event) => {
    if (password1 === "" || password2 === "") {
      setResetButtonClicked(true);
    }
    if (
      !containsLower ||
      !containsUpper ||
      !containsNumber ||
      !containsSymbol ||
      !(password1.length >= 8 && password1.length <= 40)
    ) {
      setErrorMessage("Password does not fullfil the above constraints.");
    }
    if (
      password1 !== "" &&
      password2 !== "" &&
      password1 === password2 &&
      containsLower &&
      containsUpper &&
      containsNumber &&
      containsSymbol &&
      password1.length >= 8 &&
      password1.length <= 40
    ) {
      setShowLoader(true);
      fetch(environment.loginAppAPI + Constants.setPassword, {
        method: "POST",
        body: JSON.stringify({
          UserPass: {
            ak: accountKey,
            password: password1,
          },
        }),
        headers: {
          "Content-Type": "application/json",
        },
      })
        .then((res) => res.json())
        .then(
          (result) => {
            setShowLoader(false);
            if (result.dataStatus.isSuccess) {
              props.showSuccessToast(result.dataStatus.message);
              history.push("/myBooks/login");
            } else {
              props.showFailureToast(result.dataStatus.message);
            }
          },
          (error) => {
            console.log(error);
          }
        );
    }
  };

  return (
    <div className="App col-12 d-flex align-items-center myBooks">
      <div className="container custom-container">
        <div className="row flex-direction-col-reverse content-box m-4 m-lg-0">
          <div className="col-lg-6 d-none d-lg-flex align-items-center justify-content-lg-start justify-content-center description-box position-relative">
            <div className="d-flex flex-column margin-interaction-card">
              <div className="font-20-600 text-align-left">
                Set your Password
              </div>
              <Description
                className="description"
                text="Use a unique password to keep your account secure"
              ></Description>
              <img
                src={ForgotPasswordPageImage}
                alt=""
                className="forget-password-image mt-3"
              />

              <div className="padding-top d-block">
                <HighlightText
                  className="grey text-align-left font-12-400 center-on-medium-devices"
                  subClassName="blue underline"
                  text1="Need Help ? We are just a click away"
                  text2=""
                  subText="Contact us"
                  hasHyperLink={true}
                  hyperLink="https://www.zetran.com/contact-us/"
                ></HighlightText>
              </div>
            </div>
          </div>
          <div className="col-lg-6 col-md-12 d-lg-flex d-block align-items-center">
            <div className="mx-auto mx-lg-0 interaction-card">
              <div className="d-flex flex-wrap justify-content-center py-lg-3">
                <img
                  src="https://cdn.zetran.com/assets-mybooks/accounts-portal/myBooks_logo_Black.png"
                  alt=""
                  className="logo-image"
                />
              </div>
              <div className="font-20-600 d-lg-none b-block my-3">
                Set your Password
              </div>
              <div className="bottom-15-padding">
                <label className="label">New Password</label>
                <PasswordTextField
                  className={`${password1 !== "" ? "value-entered" : ""}`}
                  value={password1}
                  onValid={onValidPassword1Handler}
                  changeFlag={changePassword1FlagHandler}
                  onBlur={() => {
                    setPasswordDoesNotMatch(
                      password2 === "" ? false : !(password1 === password2)
                    );
                  }}
                ></PasswordTextField>
                <label className="mt-1 poppins-14 d-block text-align-left">
                  <i
                    className={`fas ${
                      containsUpper
                        ? "fa-check-circle tick-style"
                        : "fa-times-circle wrong-style"
                    }`}
                  ></i>
                  Contains Upper Case
                </label>
                <label className="poppins-14 d-block text-align-left">
                  <i
                    className={`fas ${
                      containsLower
                        ? "fa-check-circle tick-style"
                        : "fa-times-circle wrong-style"
                    }`}
                  ></i>
                  Contains Lower Case
                </label>
                <label className="poppins-14 d-block text-align-left">
                  <i
                    className={`fas ${
                      containsSymbol
                        ? "fa-check-circle tick-style"
                        : "fa-times-circle wrong-style"
                    }`}
                  ></i>
                  Contains Symbol
                </label>
                <label className="poppins-14 d-block text-align-left">
                  <i
                    className={`fas ${
                      containsNumber
                        ? "fa-check-circle tick-style"
                        : "fa-times-circle wrong-style"
                    }`}
                  ></i>
                  Contains Number
                </label>
                <label className="poppins-14 d-block text-align-left">
                  <i
                    className={`fas ${
                      hasLength
                        ? "fa-check-circle tick-style"
                        : "fa-times-circle wrong-style"
                    }`}
                  ></i>
                  Has length between 8 and 40 characters
                </label>
              </div>

              <div className="bottom-15-padding">
                <label className="label">Confirm your Password</label>
                <PasswordTextField
                  className={`${password2 !== "" ? "value-entered" : ""}`}
                  value={password2}
                  onValid={onValidPassword2Handler}
                  changeFlag={changePassword2FlagHandler}
                  onBlur={() => {
                    setPasswordDoesNotMatch(
                      password2 === "" ? false : !(password1 === password2)
                    );
                  }}
                ></PasswordTextField>
                {(resetButtonClicked ||
                  passwordDoesNotMatch ||
                  errorMessage.length !== 0) && (
                  <label className="result-label">
                    {password2 === "" || password1 === ""
                      ? "*Both Password and Re-Enter password is required."
                      : password1 !== password2
                      ? "Passwords doesn't match."
                      : errorMessage.length !== 0
                      ? errorMessage
                      : ""}
                  </label>
                )}
              </div>

              <button className="button d-flex flex-wrap align-items-center justify-content-center mt-1" onClick={ContinueToStep2}>
                {!showLoader && (
                  <>
                    <div className="mr-2">Set Password</div>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      id="Outline"
                      viewBox="0 0 24 24"
                      width="24"
                      height="24"
                    >
                      <path
                        fill="#fff"
                        d="M18,12h0a2,2,0,0,0-.59-1.4l-4.29-4.3a1,1,0,0,0-1.41,0,1,1,0,0,0,0,1.42L15,11H5a1,1,0,0,0,0,2H15l-3.29,3.29a1,1,0,0,0,1.41,1.42l4.29-4.3A2,2,0,0,0,18,12Z"
                      />
                    </svg>
                  </>
                )}
                {showLoader && (
                  <div className="spinner-border" role="status"></div>
                )}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default InvitedUserPassword;
